var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQuestionCircle = function SvgQuestionCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23879_20198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.500244C3.86 0.500244 0.5 3.86024 0.5 8.00024C0.5 12.1402 3.86 15.5002 8 15.5002C12.14 15.5002 15.5 12.1402 15.5 8.00024C15.5 3.86024 12.14 0.500244 8 0.500244ZM8.75 13.2502H7.25V11.7502H8.75V13.2502ZM10.3025 7.43774L9.6275 8.12774C9.0875 8.67524 8.75 9.12524 8.75 10.2502H7.25V9.87524C7.25 9.05024 7.5875 8.30024 8.1275 7.75274L9.0575 6.80774C9.335 6.53774 9.5 6.16274 9.5 5.75024C9.5 4.92524 8.825 4.25024 8 4.25024C7.175 4.25024 6.5 4.92524 6.5 5.75024H5C5 4.09274 6.3425 2.75024 8 2.75024C9.6575 2.75024 11 4.09274 11 5.75024C11 6.41024 10.73 7.01024 10.3025 7.43774Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23879_20198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.000244141)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionCircle);
export default ForwardRef;